import React, { useState } from "react";
import { Image, createStyles } from "@mantine/core";

import { motion } from "framer-motion";

interface HomeImageProps {
  imgName: string;
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

const useStyles = createStyles(() => ({
  img: {
    cursor: "pointer",
  },
  hidden: {
    visibility: "hidden",
  },
}));

const HomeImage = ({ imgName, loading, setLoading }: HomeImageProps) => {
  const { classes, cx } = useStyles();
  const [img, setImg] = useState(imgName);

  const switchImg = () => {
    setImg(img.includes("color") ? imgName : `${imgName}-color`);
  };

  return (
    <motion.div whileHover={{ y: "-15px", transition: { duration: 0.2 } }}>
      {img && (
        <div
          className={cx(classes.img, { [classes.hidden]: loading === true })}
        >
          <Image
            onClick={switchImg}
            height={700}
            width="100%"
            src={require(`images/${img}.jpg`)}
            alt="loading..."
            onLoad={() => {
              setLoading(false);
            }}
          />
        </div>
      )}
    </motion.div>
  );
};

export default HomeImage;
